import React from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PendingList from "./PendingList";

const ApproveUserListing = () => {
  const navigate = useNavigate();

  return (
    <div className="card shadow-sm border-0">
      <PageTitle
        activeMenu="List"
        motherMenu="Users"
        Button={() => (
          <div className="d-flex flex-wrap gap-2">
            <Button
              variant="outline-primary"
              className="btn btn-outline-primary btn-sm"
              onClick={() => navigate("/create-new-user?mode=import")}
            >
              <i className="fa fa-file-excel me-1"></i>
              Import Bulk Users
            </Button>
            <Button
              variant="primary"
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/create-new-user")}
            >
              <i className="fa fa-user-plus me-1"></i>
              Add New User
            </Button>
          </div>
        )}
      />
      <div className="border-top border-2 mx-4" style={{ borderColor: "#D1D5DB" }} />
      <PendingList />
    </div>
  );
};

export default ApproveUserListing;
